import { render, staticRenderFns } from "./ProductContent.component.vue?vue&type=template&id=3b92acbc&scoped=true"
import script from "./ProductContent.component.vue?vue&type=script&lang=js"
export * from "./ProductContent.component.vue?vue&type=script&lang=js"
import style0 from "./ProductContent.component.vue?vue&type=style&index=0&id=3b92acbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b92acbc",
  null
  
)

export default component.exports